import LoginCard from "./MoneyTransferComponent/LoginCard";
import "./MoneyTransfer.css";
import { useState } from "react";
import TransectionCard from "./MoneyTransferComponent/TranxnCard";
import BeneficiaryCard from "./MoneyTransferComponent/BeneficiaryCard";
import { moneyTransferAction } from "service/Auth.services";
import { MONEY_TRANSFER_ACTION } from "constants/app";
import ShowToast from "components/ShowToast";
import { useSession } from "hooks/useSession";
import useLocationService from "hooks/useLocationService";
import { fetchWrapper } from "utils/apiFetch";
const MoneyTransfer = () => {
  const [shouldShowTranxs, setShouldShowTranxs] = useState(false);
  const [shouldShowRefundSection, setShouldShowRefundSection] = useState(false);
  const [beneDetails, setBeneDetails] = useState({});
  const [selectedBene, setSelectedBene] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [selectedBankData, setSelectedBankData] = useState({});
  const [showReceipt, setShowReceipt] = useState(false);
  const [receiptData, setReceiptData] = useState(null);
  const [shouldShowTranxs1, setShouldShowTranxs1] = useState(false);
  const [cusName, setcusName] = useState("");
  const {
    location,

    permission,
    getLocation,
    checkPermission,
  } = useLocationService(false);
  const { userid } = useSession();
  const config = {
    title: "Money Management",
  };

  async function getPhoneNumbersDetails(phoneNumber) {
    const formData = new FormData();
    formData.set("userid", userid);
    formData.set("long", location.lng);
    formData.set("lat", location.lat);
    formData.set("mobile", phoneNumber);

    const res = await moneyTransferAction(formData, MONEY_TRANSFER_ACTION.SEARCH_CUSTOMER);

    if (!res || !res.status) {
      ShowToast(res.data || "No Data Found", "danger");
    } else if (res?.status) {
      ShowToast(res.data || "Details found", "success");
      setPhoneNumber(phoneNumber);


    }
    return res;
  }

  async function getBankDetails(phoneNumber) {
    const formData = new FormData();
    formData.set("mobile", phoneNumber);
    formData.set("userid", userid);
    formData.set("long", location.lng);
    formData.set("lat", location.lat);

    const res = await moneyTransferAction(formData, MONEY_TRANSFER_ACTION.SEARCH_CUSTOMER);

    if (!res || !res.status) {
      ShowToast(res.data || "No Bebe Data Found", "danger");
    } else if (res?.status) {
      debugger;
      setSelectedBankData(res);
      setBeneDetails(res.newdata);
      setcusName(`${res.newdata.firstName} ${res.newdata.lastName}`);
      ShowToast(res.data || "Bene Details Retreived Successfully!!", "success");
    }
    return res;
  }

  function transferBtnClickHandler(phoneNumber) {
    getBankDetails(phoneNumber);
    setShouldShowTranxs(true);
  }

  function refundBtnClickHandler() {
    setShouldShowRefundSection(true);
  }

  function resetHandler() {
    setShouldShowRefundSection(false);
    setShouldShowTranxs(false);
  }
  function onBeneficiarySelect(bene) {
    setSelectedBene(bene);
    setShouldShowTranxs1(true);
  }
  function handleCancelTransaction() {
    setShouldShowTranxs1(false);
    setSelectedBene(null);  
  }
  const handleTransactionSuccess = async (refid) => {
    console.log("Transaction successful with refid:", refid);

    if (!refid || ["", "null", "undefined"].includes(refid)) {
      console.warn("No valid refid found. Receipt will not open.");
      return;
    }

    try {
      debugger;
      const url = `https://api.mokshiq.in/show_receipt_dmt?id=${refid}`;
      const response = await fetchWrapper(url);

      console.log("Receipt API Response:", response);

      // 🔥 NORMALIZE DATA
      const receipt =
        response?.data?.data ||   // axios-style
        response?.data ||         // fetchWrapper returns only data
        null;

      if (!receipt) {
        console.error("No receipt data for refid:", refid);
        return;
      }

      setReceiptData(receipt);
      setShowReceipt(true);
      // resetTransactionFlow();

    } catch (err) {
      console.error("Receipt fetch error:", err);
    }
  };
  return (
    <>
      <main>
        <div className="container-fluid">
          {/* Breadcrumb */}
          <div className="row m-1">
            <div className="col-12 d-flex justify-content-between align-items-center">
              <div>
                <h4 className="main-title">{config.title}</h4>
                <ul className="app-line-breadcrumbs mb-3">
                  <li>
                    <a className="f-s-14 f-w-500" href="#">
                      <span>
                        <i
                          className={`${config.breadcrumbIcon || "ph-duotone ph-table"
                            } f-s-16`}
                        ></i>
                      </span>
                    </a>
                  </li>
                  <li className="active">
                    <a className="f-s-14 f-w-500" href="#">
                      {config.title}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="row m-1 ">
            <div className="col-4 d-flex justify-content-between align-items-center">
              <div className="custom-card w-100">
                <LoginCard
                  handleSubmitAction={getPhoneNumbersDetails}
                  handleTransferAction={transferBtnClickHandler}
                  handleRefundAction={refundBtnClickHandler}
                  resetHandler={resetHandler}
                  location={location}
                />
              </div>
            </div>
            <div className="col-4 d-flex justify-content-between align-items-center">
              <div className="custom-card w-100">
                {shouldShowTranxs ? (
                  <BeneficiaryCard
                    bankData={selectedBankData}
                    setBankData={setSelectedBankData}
                    setBeneData={setBeneDetails}
                    beneData={beneDetails}
                    bankOptions={{}}
                    phone={phoneNumber}
                    userId={userid}
                    location={location}
                    onSelectBeneficiary={onBeneficiarySelect}

                  />
                ) : (
                  <></>
                )}
              </div>
            </div>
            <div className="col-4 d-flex justify-content-between align-items-center">
              <div className="custom-card w-100">
                {shouldShowTranxs && shouldShowTranxs1? (
                  <TransectionCard
                    bankData={selectedBankData}
                    phone={phoneNumber}
                    userId={userid}
                    location={location}
                    beneId={selectedBene.id}
                    account={selectedBene.account}
                    ifsc={selectedBene.ifsc}
                    beneName={selectedBene.beneName}
                    cusName={cusName}
                    onSuccess={handleTransactionSuccess}
                    onCancel={handleCancelTransaction}
                  />
                ) : (
                  <></>
                )}
              </div>
            </div>
          </div>
        </div>
      </main>
      {shouldShowRefundSection ? <>Transection card</> : <></>}
    </>
  );
};

export default MoneyTransfer;
